// Contenuti delle pagine legali (Privacy e Cookie Policy) nelle 4 lingue del sito.
// Markup supportato nei testi: **grassetto** e link automatico per info@xsalesconsulting.com.

export const LEGAL = {
  privacy: {
    it: {
      title: "Privacy Policy",
      updated: "26 ottobre 2026",
      updatedLabel: "Ultimo aggiornamento",
      metaDesc: "Informativa privacy di XSALES CONSULTING LTD (Manno, Ticino): dati raccolti, finalità, diritti e contatti del titolare del trattamento.",
      back: "Torna alla home",
      sections: [
        { title: "1. Titolare del trattamento", blocks: [
          { p: "Il titolare del trattamento dei dati personali è **XSALES CONSULTING LTD**, con sede in 61 Bridge Street, Kington, United Kingdom HR5 3DJ." },
          { p: "Contatti: info@xsalesconsulting.com, tel. +41 78 204 21 72 / +39 353 407 8525." },
        ]},
        { title: "2. Dati che raccogliamo", blocks: [
          { p: "Raccogliamo esclusivamente i dati che ci fornisci volontariamente:" },
          { ul: [
            "Nome e cognome, email, azienda e messaggio tramite il modulo di richiesta demo del sito",
            "Nome, argomento di interesse e messaggio tramite l'assistente guidato del sito",
            "Nome, cognome, email, telefono, azienda e ruolo tramite i moduli di lead generation di LinkedIn, quando scegli di inviarceli",
            "Dati di navigazione aggregati e anonimi tramite strumenti di analisi (solo con il tuo consenso)",
          ]},
        ]},
        { title: "3. Finalità e base giuridica", blocks: [
          { p: "**a) Rispondere alle tue richieste.** Usiamo i dati per rispondere alle richieste di informazioni, organizzare la consulenza gratuita e gestire il rapporto precontrattuale. La base giuridica è l'esecuzione di misure precontrattuali su tua richiesta (art. 6.1.b GDPR / UK GDPR)." },
          { p: "**b) Comunicazioni commerciali.** Con il tuo consenso esplicito usiamo i dati per inviarti comunicazioni su servizi, novità ed eventi di XS Consulting. La base giuridica è il consenso (art. 6.1.a GDPR / UK GDPR; art. 31 nLPD per la Svizzera). Puoi revocarlo in qualsiasi momento, senza conseguenze, scrivendo a info@xsalesconsulting.com o usando il link di disiscrizione presente in ogni comunicazione." },
          { p: "**c) Analisi del sito.** Con il tuo consenso, dato tramite il banner cookie, raccogliamo statistiche anonime per migliorare il sito." },
          { p: "Il conferimento dei dati per la finalità a) serve a rispondere alla tua richiesta. Per le finalità b) e c) è facoltativo." },
        ]},
        { title: "4. Conservazione", blocks: [
          { ul: [
            "Dati per le richieste di informazioni: fino a 24 mesi dall'ultimo contatto, salvo che nasca un rapporto commerciale",
            "Dati per le comunicazioni commerciali: fino alla revoca del consenso",
            "Dati legati a un rapporto contrattuale: per la durata prevista dagli obblighi di legge",
          ]},
          { p: "Puoi chiederne la cancellazione in qualsiasi momento." },
        ]},
        { title: "5. Terze parti e destinatari", blocks: [
          { ul: [
            "**LinkedIn (LinkedIn Ireland Unlimited Company)**: se compili un nostro modulo di lead generation su LinkedIn, i dati vengono raccolti tramite la piattaforma e trasmessi a noi. Il loro trattamento da parte di LinkedIn è soggetto alla privacy policy di LinkedIn.",
            "**WhatsApp (Meta Platforms)**: se scegli di contattarci su WhatsApp, la conversazione è soggetta alla privacy policy di WhatsApp.",
            "**Servizio email transazionale**: per inviarti conferme e notifiche relative alla tua richiesta.",
            "**PostHog**: analisi di navigazione, attiva solo dopo il tuo consenso tramite il banner cookie.",
            "**Hosting**: il sito è ospitato su infrastruttura cloud Emergent.",
          ]},
          { p: "Non vendiamo né cediamo i tuoi dati a terzi per loro finalità di marketing." },
        ]},
        { title: "6. Trasferimento dei dati all'estero", blocks: [
          { p: "Alcuni fornitori possono trattare i dati fuori dallo Spazio Economico Europeo, dal Regno Unito o dalla Svizzera, ad esempio negli Stati Uniti. In questi casi il trasferimento avviene sulla base di decisioni di adeguatezza, come l'EU-US Data Privacy Framework e lo Swiss-US Data Privacy Framework, oppure di clausole contrattuali standard approvate dalle autorità competenti." },
        ]},
        { title: "7. I tuoi diritti", blocks: [
          { p: "In base al GDPR, allo UK GDPR e alla Legge federale sulla protezione dei dati (nLPD, Svizzera) hai diritto di:" },
          { ul: [
            "accesso, rettifica e cancellazione dei dati",
            "limitazione del trattamento e portabilità dei dati",
            "opposizione al trattamento",
            "revoca del consenso in qualsiasi momento, senza pregiudicare la liceità del trattamento già effettuato",
          ]},
          { p: "Per esercitarli scrivi a info@xsalesconsulting.com. Rispondiamo entro 30 giorni." },
          { p: "Hai anche il diritto di presentare reclamo a un'autorità di controllo:" },
          { ul: [
            "Regno Unito: Information Commissioner's Office (ICO), ico.org.uk",
            "Italia: Garante per la protezione dei dati personali, garanteprivacy.it",
            "Svizzera: Incaricato federale della protezione dei dati e della trasparenza (IFPDT), edoeb.admin.ch",
          ]},
        ]},
        { title: "8. Sicurezza", blocks: [
          { p: "Adottiamo misure tecniche e organizzative adeguate per proteggere i tuoi dati da accessi non autorizzati, perdita o divulgazione. Le comunicazioni con questo sito avvengono tramite connessione cifrata (HTTPS)." },
        ]},
        { title: "9. Modifiche", blocks: [
          { p: "Possiamo aggiornare questa informativa. La versione in vigore è sempre pubblicata su questa pagina, con la data dell'ultimo aggiornamento." },
        ]},
      ],
    },
    en: {
      title: "Privacy Policy",
      updated: "26 October 2026",
      updatedLabel: "Last updated",
      metaDesc: "Privacy policy of XSALES CONSULTING LTD (Manno, Ticino): data collected, purposes, your rights and controller contacts.",
      back: "Back to home",
      sections: [
        { title: "1. Data controller", blocks: [
          { p: "The data controller is **XSALES CONSULTING LTD**, based at 61 Bridge Street, Kington, United Kingdom HR5 3DJ." },
          { p: "Contacts: info@xsalesconsulting.com, tel. +41 78 204 21 72 / +39 353 407 8525." },
        ]},
        { title: "2. Data we collect", blocks: [
          { p: "We only collect data you voluntarily provide to us:" },
          { ul: [
            "First and last name, email, company and message via the site's demo request form",
            "Name, topic of interest and message via the site's guided assistant",
            "First name, last name, email, phone, company and role via LinkedIn lead generation forms, when you choose to send them to us",
            "Aggregated and anonymous browsing data via analytics tools (only with your consent)",
          ]},
        ]},
        { title: "3. Purposes and legal basis", blocks: [
          { p: "**a) Responding to your requests.** We use the data to answer information requests, organise the free consultation and manage the pre-contractual relationship. The legal basis is the performance of pre-contractual measures at your request (art. 6.1.b GDPR / UK GDPR)." },
          { p: "**b) Marketing communications.** With your explicit consent we use the data to send you communications about XS Consulting services, news and events. The legal basis is consent (art. 6.1.a GDPR / UK GDPR; art. 31 nFADP for Switzerland). You can withdraw it at any time, without consequences, by writing to info@xsalesconsulting.com or using the unsubscribe link in every communication." },
          { p: "**c) Website analytics.** With your consent, given via the cookie banner, we collect anonymous statistics to improve the site." },
          { p: "Providing data for purpose a) is needed to respond to your request. For purposes b) and c) it is optional." },
        ]},
        { title: "4. Data retention", blocks: [
          { ul: [
            "Data for information requests: up to 24 months from the last contact, unless a business relationship arises",
            "Data for marketing communications: until consent is withdrawn",
            "Data linked to a contractual relationship: for the duration required by legal obligations",
          ]},
          { p: "You can request deletion at any time." },
        ]},
        { title: "5. Third parties and recipients", blocks: [
          { ul: [
            "**LinkedIn (LinkedIn Ireland Unlimited Company)**: if you fill in one of our lead generation forms on LinkedIn, the data is collected through the platform and transmitted to us. LinkedIn's processing is subject to LinkedIn's privacy policy.",
            "**WhatsApp (Meta Platforms)**: if you choose to contact us on WhatsApp, the conversation is subject to WhatsApp's privacy policy.",
            "**Transactional email service**: to send you confirmations and notifications about your request.",
            "**PostHog**: browsing analytics, active only after your consent via the cookie banner.",
            "**Hosting**: the site is hosted on Emergent cloud infrastructure.",
          ]},
          { p: "We do not sell or share your data with third parties for their marketing purposes." },
        ]},
        { title: "6. International data transfers", blocks: [
          { p: "Some providers may process data outside the European Economic Area, the United Kingdom or Switzerland, for example in the United States. In these cases the transfer takes place on the basis of adequacy decisions, such as the EU-US Data Privacy Framework and the Swiss-US Data Privacy Framework, or standard contractual clauses approved by the competent authorities." },
        ]},
        { title: "7. Your rights", blocks: [
          { p: "Under the GDPR, the UK GDPR and the Swiss Federal Act on Data Protection (nFADP, Switzerland) you have the right to:" },
          { ul: [
            "access, rectification and erasure of data",
            "restriction of processing and data portability",
            "objection to processing",
            "withdrawal of consent at any time, without affecting the lawfulness of processing already carried out",
          ]},
          { p: "To exercise them write to info@xsalesconsulting.com. We respond within 30 days." },
          { p: "You also have the right to lodge a complaint with a supervisory authority:" },
          { ul: [
            "United Kingdom: Information Commissioner's Office (ICO), ico.org.uk",
            "Italy: Garante per la protezione dei dati personali, garanteprivacy.it",
            "Switzerland: Federal Data Protection and Information Commissioner (FDPIC), edoeb.admin.ch",
          ]},
        ]},
        { title: "8. Security", blocks: [
          { p: "We adopt appropriate technical and organisational measures to protect your data from unauthorised access, loss or disclosure. Communications with this site take place over an encrypted connection (HTTPS)." },
        ]},
        { title: "9. Changes", blocks: [
          { p: "We may update this policy. The version in force is always published on this page, with the date of the last update." },
        ]},
      ],
    },
    fr: {
      title: "Politique de confidentialité",
      updated: "26 octobre 2026",
      updatedLabel: "Dernière mise à jour",
      metaDesc: "Politique de confidentialité de XSALES CONSULTING LTD (Manno, Tessin) : données collectées, finalités, droits et contacts du responsable.",
      back: "Retour à l'accueil",
      sections: [
        { title: "1. Responsable du traitement", blocks: [
          { p: "Le responsable du traitement des données personnelles est **XSALES CONSULTING LTD**, sis à 61 Bridge Street, Kington, United Kingdom HR5 3DJ." },
          { p: "Contacts : info@xsalesconsulting.com, tél. +41 78 204 21 72 / +39 353 407 8525." },
        ]},
        { title: "2. Données que nous collectons", blocks: [
          { p: "Nous collectons exclusivement les données que vous nous fournissez volontairement :" },
          { ul: [
            "Nom et prénom, email, entreprise et message via le formulaire de demande de démo du site",
            "Nom, sujet d'intérêt et message via l'assistant guidé du site",
            "Nom, prénom, email, téléphone, entreprise et fonction via les formulaires de lead generation LinkedIn, lorsque vous choisissez de nous les envoyer",
            "Données de navigation agrégées et anonymes via des outils d'analyse (uniquement avec votre consentement)",
          ]},
        ]},
        { title: "3. Finalités et base juridique", blocks: [
          { p: "**a) Répondre à vos demandes.** Nous utilisons les données pour répondre aux demandes d'informations, organiser la consultation gratuite et gérer la relation précontractuelle. La base juridique est l'exécution de mesures précontractuelles à votre demande (art. 6.1.b RGPD / UK GDPR)." },
          { p: "**b) Communications commerciales.** Avec votre consentement explicite, nous utilisons les données pour vous envoyer des communications sur les services, nouveautés et événements de XS Consulting. La base juridique est le consentement (art. 6.1.a RGPD / UK GDPR ; art. 31 nLPD pour la Suisse). Vous pouvez le retirer à tout moment, sans conséquences, en écrivant à info@xsalesconsulting.com ou via le lien de désinscription présent dans chaque communication." },
          { p: "**c) Analyse du site.** Avec votre consentement, donné via la bannière cookie, nous collectons des statistiques anonymes pour améliorer le site." },
          { p: "La fourniture des données pour la finalité a) est nécessaire pour répondre à votre demande. Pour les finalités b) et c), elle est facultative." },
        ]},
        { title: "4. Conservation", blocks: [
          { ul: [
            "Données relatives aux demandes d'informations : jusqu'à 24 mois après le dernier contact, sauf si une relation commerciale naît",
            "Données pour les communications commerciales : jusqu'au retrait du consentement",
            "Données liées à une relation contractuelle : pendant la durée prévue par les obligations légales",
          ]},
          { p: "Vous pouvez en demander la suppression à tout moment." },
        ]},
        { title: "5. Tiers et destinataires", blocks: [
          { ul: [
            "**LinkedIn (LinkedIn Ireland Unlimited Company)** : si vous remplissez l'un de nos formulaires de lead generation sur LinkedIn, les données sont collectées via la plateforme et transmises à nous. Leur traitement par LinkedIn est soumis à la politique de confidentialité de LinkedIn.",
            "**WhatsApp (Meta Platforms)** : si vous choisissez de nous contacter sur WhatsApp, la conversation est soumise à la politique de confidentialité de WhatsApp.",
            "**Service d'email transactionnel** : pour vous envoyer des confirmations et notifications relatives à votre demande.",
            "**PostHog** : analyse de navigation, actif uniquement après votre consentement via la bannière cookie.",
            "**Hébergement** : le site est hébergé sur l'infrastructure cloud Emergent.",
          ]},
          { p: "Nous ne vendons ni ne cédons vos données à des tiers pour leurs finalités de marketing." },
        ]},
        { title: "6. Transfert des données à l'étranger", blocks: [
          { p: "Certains fournisseurs peuvent traiter les données en dehors de l'Espace économique européen, du Royaume-Uni ou de la Suisse, par exemple aux États-Unis. Dans ces cas, le transfert a lieu sur la base de décisions d'adéquation, comme l'EU-US Data Privacy Framework et le Swiss-US Data Privacy Framework, ou de clauses contractuelles types approuvées par les autorités compétentes." },
        ]},
        { title: "7. Vos droits", blocks: [
          { p: "En vertu du RGPD, du UK GDPR et de la Loi fédérale sur la protection des données (nLPD, Suisse), vous avez le droit de :" },
          { ul: [
            "accès, rectification et suppression des données",
            "limitation du traitement et portabilité des données",
            "opposition au traitement",
            "retrait du consentement à tout moment, sans porter atteinte à la licéité du traitement déjà effectué",
          ]},
          { p: "Pour les exercer, écrivez à info@xsalesconsulting.com. Nous répondons sous 30 jours." },
          { p: "Vous avez également le droit de déposer une réclamation auprès d'une autorité de contrôle :" },
          { ul: [
            "Royaume-Uni : Information Commissioner's Office (ICO), ico.org.uk",
            "Italie : Garante per la protezione dei dati personali, garanteprivacy.it",
            "Suisse : Préposé fédéral à la protection des données et à la transparence (PFPDT), edoeb.admin.ch",
          ]},
        ]},
        { title: "8. Sécurité", blocks: [
          { p: "Nous adoptons des mesures techniques et organisationnelles appropriées pour protéger vos données contre tout accès non autorisé, perte ou divulgation. Les communications avec ce site se font via une connexion chiffrée (HTTPS)." },
        ]},
        { title: "9. Modifications", blocks: [
          { p: "Nous pouvons mettre à jour la présente politique. La version en vigueur est toujours publiée sur cette page, avec la date de la dernière mise à jour." },
        ]},
      ],
    },
    de: {
      title: "Datenschutzerklärung",
      updated: "26. Oktober 2026",
      updatedLabel: "Letzte Aktualisierung",
      metaDesc: "Datenschutzerklärung der XSALES CONSULTING LTD (Manno, Tessin): erhobene Daten, Zwecke, Ihre Rechte und Kontakt.",
      back: "Zurück zur Startseite",
      sections: [
        { title: "1. Verantwortliche Stelle", blocks: [
          { p: "Verantwortliche Stelle für die Verarbeitung personenbezogener Daten ist **XSALES CONSULTING LTD**, mit Sitz in 61 Bridge Street, Kington, United Kingdom HR5 3DJ." },
          { p: "Kontakt: info@xsalesconsulting.com, Tel. +41 78 204 21 72 / +39 353 407 8525." },
        ]},
        { title: "2. Daten, die wir erheben", blocks: [
          { p: "Wir erheben ausschließlich Daten, die Sie uns freiwillig zur Verfügung stellen:" },
          { ul: [
            "Vor- und Nachname, E-Mail, Unternehmen und Nachricht über das Demo-Anfrageformular der Website",
            "Name, Interessenthema und Nachricht über den geführten Assistenten der Website",
            "Vorname, Nachname, E-Mail, Telefon, Unternehmen und Position über LinkedIn-Lead-Generation-Formulare, wenn Sie sich entscheiden, sie uns zu senden",
            "Aggregierte und anonyme Navigationsdaten über Analyse-Tools (nur mit Ihrer Einwilligung)",
          ]},
        ]},
        { title: "3. Zwecke und Rechtsgrundlage", blocks: [
          { p: "**a) Beantwortung Ihrer Anfragen.** Wir verwenden die Daten, um Informationsanfragen zu beantworten, die kostenlose Beratung zu organisieren und das vorvertragliche Verhältnis zu verwalten. Rechtsgrundlage ist die Durchführung vorvertraglicher Maßnahmen auf Ihre Anfrage (Art. 6.1.b DSGVO / UK GDPR)." },
          { p: "**b) Kommerzielle Mitteilungen.** Mit Ihrer ausdrücklichen Einwilligung verwenden wir die Daten, um Ihnen Mitteilungen über Dienstleistungen, Neuigkeiten und Veranstaltungen von XS Consulting zu senden. Rechtsgrundlage ist die Einwilligung (Art. 6.1.a DSGVO / UK GDPR; Art. 31 nDSG für die Schweiz). Sie können sie jederzeit ohne Konsequenzen widerrufen, indem Sie an info@xsalesconsulting.com schreiben oder den Abmeldelink in jeder Mitteilung verwenden." },
          { p: "**c) Website-Analyse.** Mit Ihrer Einwilligung, erteilt über das Cookie-Banner, erheben wir anonyme Statistiken zur Verbesserung der Website." },
          { p: "Die Bereitstellung der Daten für Zweck a) ist erforderlich, um Ihre Anfrage zu beantworten. Für die Zwecke b) und c) ist sie freiwillig." },
        ]},
        { title: "4. Speicherdauer", blocks: [
          { ul: [
            "Daten für Informationsanfragen: bis zu 24 Monate nach dem letzten Kontakt, sofern keine Geschäftsbeziehung entsteht",
            "Daten für kommerzielle Mitteilungen: bis zum Widerruf der Einwilligung",
            "Daten im Zusammenhang mit einem Vertragsverhältnis: für die Dauer der gesetzlichen Verpflichtungen",
          ]},
          { p: "Sie können jederzeit die Löschung verlangen." },
        ]},
        { title: "5. Dritte und Empfänger", blocks: [
          { ul: [
            "**LinkedIn (LinkedIn Ireland Unlimited Company)**: Wenn Sie eines unserer Lead-Generation-Formulare auf LinkedIn ausfüllen, werden die Daten über die Plattform erhoben und an uns übermittelt. Deren Verarbeitung durch LinkedIn unterliegt der Datenschutzrichtlinie von LinkedIn.",
            "**WhatsApp (Meta Platforms)**: Wenn Sie uns über WhatsApp kontaktieren, unterliegt die Konversation der Datenschutzrichtlinie von WhatsApp.",
            "**Transaktionaler E-Mail-Dienst**: um Ihnen Bestätigungen und Benachrichtigungen zu Ihrer Anfrage zu senden.",
            "**PostHog**: Navigationsanalyse, nur nach Ihrer Einwilligung über das Cookie-Banner aktiv.",
            "**Hosting**: Die Website wird auf der Cloud-Infrastruktur von Emergent gehostet.",
          ]},
          { p: "Wir verkaufen Ihre Daten nicht und geben sie nicht an Dritte für deren Marketingzwecke weiter." },
        ]},
        { title: "6. Datenübertragung ins Ausland", blocks: [
          { p: "Einige Anbieter können Daten außerhalb des Europäischen Wirtschaftsraums, des Vereinigten Königreichs oder der Schweiz verarbeiten, beispielsweise in den Vereinigten Staaten. In diesen Fällen erfolgt die Übertragung auf der Grundlage von Angemessenheitsbeschlüssen, wie dem EU-US Data Privacy Framework und dem Swiss-US Data Privacy Framework, oder von Standardvertragsklauseln, die von den zuständigen Behörden genehmigt wurden." },
        ]},
        { title: "7. Ihre Rechte", blocks: [
          { p: "Nach der DSGVO, dem UK GDPR und dem Bundesgesetz über den Datenschutz (nDSG, Schweiz) haben Sie das Recht auf:" },
          { ul: [
            "Auskunft, Berichtigung und Löschung der Daten",
            "Einschränkung der Verarbeitung und Datenübertragbarkeit",
            "Widerspruch gegen die Verarbeitung",
            "jederzeitigen Widerruf der Einwilligung, ohne dass die Rechtmäßigkeit der bereits erfolgten Verarbeitung berührt wird",
          ]},
          { p: "Zur Ausübung schreiben Sie an info@xsalesconsulting.com. Wir antworten innerhalb von 30 Tagen." },
          { p: "Sie haben auch das Recht, eine Beschwerde bei einer Aufsichtsbehörde einzureichen:" },
          { ul: [
            "Vereinigtes Königreich: Information Commissioner's Office (ICO), ico.org.uk",
            "Italien: Garante per la protezione dei dati personali, garanteprivacy.it",
            "Schweiz: Eidgenössischer Datenschutz- und Öffentlichkeitsbeauftragter (EDÖB), edoeb.admin.ch",
          ]},
        ]},
        { title: "8. Sicherheit", blocks: [
          { p: "Wir treffen geeignete technische und organisatorische Maßnahmen, um Ihre Daten vor unbefugtem Zugriff, Verlust oder Offenlegung zu schützen. Die Kommunikation mit dieser Website erfolgt über eine verschlüsselte Verbindung (HTTPS)." },
        ]},
        { title: "9. Änderungen", blocks: [
          { p: "Wir können diese Erklärung aktualisieren. Die jeweils gültige Version ist immer auf dieser Seite mit dem Datum der letzten Aktualisierung veröffentlicht." },
        ]},
      ],
    },
  },
  cookie: {
    it: {
      title: "Cookie Policy",
      updated: "21 ottobre 2026",
      updatedLabel: "Ultimo aggiornamento",
      metaDesc: "Cookie Policy di XSALES CONSULTING LTD: quali cookie usiamo, perché e come gestire o revocare il consenso.",
      back: "Torna alla home",
      sections: [
        { title: "1. Cosa sono i cookie", blocks: [
          { p: "I cookie e le tecnologie simili (come il localStorage del browser) sono piccoli file o porzioni di dati che il sito salva sul tuo dispositivo per funzionare correttamente e, con il tuo consenso, per fini statistici." },
        ]},
        { title: "2. Cookie tecnici (sempre attivi)", blocks: [
          { p: "Necessari al funzionamento del sito, non richiedono consenso:" },
          { ul: [
            "**xs-lang** — ricorda la lingua che hai scelto (IT / EN / FR / DE)",
            "**xs-cookie-consent** — ricorda la tua scelta sui cookie",
          ]},
        ]},
        { title: "3. Cookie di analisi (solo con consenso)", blocks: [
          { p: "Utilizziamo **PostHog** per statistiche aggregate di navigazione (pagine visitate, interazioni). Questi strumenti si attivano solo se premi \"Accetta\" nel banner cookie. Se rifiuti, la raccolta dati di analisi resta disattivata." },
        ]},
        { title: "4. Servizi di terze parti", blocks: [
          { p: "Il pulsante e l'assistente WhatsApp aprono l'app o il sito di WhatsApp (Meta Platforms), che applica la propria cookie policy una volta uscito dal nostro sito." },
        ]},
        { title: "5. Come gestire o revocare il consenso", blocks: [
          { p: "Puoi cancellare i dati salvati dal sito tramite le impostazioni del tuo browser (cancellazione dati dei siti / localStorage) e ricomparirà il banner per una nuova scelta. Per domande: info@xsalesconsulting.com." },
        ]},
      ],
    },
    en: {
      title: "Cookie Policy",
      updated: "21 October 2026",
      updatedLabel: "Last updated",
      metaDesc: "Cookie Policy of XSALES CONSULTING LTD: which cookies we use, why, and how to manage or withdraw consent.",
      back: "Back to home",
      sections: [
        { title: "1. What cookies are", blocks: [
          { p: "Cookies and similar technologies (such as the browser's localStorage) are small files or pieces of data that the site saves on your device to work properly and, with your consent, for statistical purposes." },
        ]},
        { title: "2. Technical cookies (always active)", blocks: [
          { p: "Required for the site to function, they do not require consent:" },
          { ul: [
            "**xs-lang** — remembers the language you chose (IT / EN / FR / DE)",
            "**xs-cookie-consent** — remembers your cookie choice",
          ]},
        ]},
        { title: "3. Analytics cookies (only with consent)", blocks: [
          { p: "We use **PostHog** for aggregated browsing statistics (pages visited, interactions). These tools only activate if you press \"Accept\" in the cookie banner. If you refuse, analytics data collection stays off." },
        ]},
        { title: "4. Third-party services", blocks: [
          { p: "The WhatsApp button and assistant open the WhatsApp app or site (Meta Platforms), which applies its own cookie policy once you leave our site." },
        ]},
        { title: "5. How to manage or withdraw consent", blocks: [
          { p: "You can delete the data saved by the site through your browser settings (clearing site data / localStorage) and the banner will appear again for a new choice. Questions: info@xsalesconsulting.com." },
        ]},
      ],
    },
    fr: {
      title: "Politique de cookies",
      updated: "21 octobre 2026",
      updatedLabel: "Dernière mise à jour",
      metaDesc: "Politique de cookies de XSALES CONSULTING LTD : quels cookies nous utilisons, pourquoi, et comment gérer ou retirer votre consentement.",
      back: "Retour à l'accueil",
      sections: [
        { title: "1. Que sont les cookies", blocks: [
          { p: "Les cookies et les technologies similaires (comme le localStorage du navigateur) sont de petits fichiers ou portions de données que le site enregistre sur votre appareil pour fonctionner correctement et, avec votre consentement, à des fins statistiques." },
        ]},
        { title: "2. Cookies techniques (toujours actifs)", blocks: [
          { p: "Nécessaires au fonctionnement du site, ils ne requièrent pas de consentement :" },
          { ul: [
            "**xs-lang** — mémorise la langue choisie (IT / EN / FR / DE)",
            "**xs-cookie-consent** — mémorise votre choix concernant les cookies",
          ]},
        ]},
        { title: "3. Cookies d'analyse (uniquement avec consentement)", blocks: [
          { p: "Nous utilisons **PostHog** pour des statistiques de navigation agrégées (pages visitées, interactions). Ces outils ne s'activent que si vous appuyez sur « Accepter » dans la bannière cookie. Si vous refusez, la collecte de données d'analyse reste désactivée." },
        ]},
        { title: "4. Services tiers", blocks: [
          { p: "Le bouton et l'assistant WhatsApp ouvrent l'application ou le site WhatsApp (Meta Platforms), qui applique sa propre politique de cookies une fois que vous quittez notre site." },
        ]},
        { title: "5. Comment gérer ou retirer le consentement", blocks: [
          { p: "Vous pouvez supprimer les données enregistrées par le site via les paramètres de votre navigateur (suppression des données des sites / localStorage) et la bannière réapparaîtra pour un nouveau choix. Questions : info@xsalesconsulting.com." },
        ]},
      ],
    },
    de: {
      title: "Cookie-Richtlinie",
      updated: "21. Oktober 2026",
      updatedLabel: "Letzte Aktualisierung",
      metaDesc: "Cookie-Richtlinie der XSALES CONSULTING LTD: welche Cookies wir verwenden, warum, und wie Sie die Einwilligung verwalten oder widerrufen.",
      back: "Zurück zur Startseite",
      sections: [
        { title: "1. Was sind Cookies", blocks: [
          { p: "Cookies und ähnliche Technologien (wie der localStorage des Browsers) sind kleine Dateien oder Datenmengen, die die Website auf Ihrem Gerät speichert, um ordnungsgemäß zu funktionieren und – mit Ihrer Einwilligung – für statistische Zwecke." },
        ]},
        { title: "2. Technische Cookies (immer aktiv)", blocks: [
          { p: "Für den Betrieb der Website erforderlich, sie benötigen keine Einwilligung:" },
          { ul: [
            "**xs-lang** — speichert die von Ihnen gewählte Sprache (IT / EN / FR / DE)",
            "**xs-cookie-consent** — speichert Ihre Cookie-Auswahl",
          ]},
        ]},
        { title: "3. Analyse-Cookies (nur mit Einwilligung)", blocks: [
          { p: "Wir verwenden **PostHog** für aggregierte Navigationsstatistiken (besuchte Seiten, Interaktionen). Diese Tools werden nur aktiviert, wenn Sie im Cookie-Banner auf „Akzeptieren“ klicken. Bei Ablehnung bleibt die Analyse-Datenerhebung deaktiviert." },
        ]},
        { title: "4. Dienste von Drittanbietern", blocks: [
          { p: "Die WhatsApp-Schaltfläche und der Assistent öffnen die WhatsApp-App oder -Website (Meta Platforms), die nach dem Verlassen unserer Website ihre eigene Cookie-Richtlinie anwendet." },
        ]},
        { title: "5. Einwilligung verwalten oder widerrufen", blocks: [
          { p: "Sie können die von der Website gespeicherten Daten über die Einstellungen Ihres Browsers löschen (Website-Daten / localStorage löschen); das Banner erscheint dann erneut für eine neue Auswahl. Fragen: info@xsalesconsulting.com." },
        ]},
      ],
    },
  },
};
